import React, { useState, useEffect } from "react";
import Announcement from "./view/_announcement-banner"
import AnnouncementPopup from "./view/_announcement-popup"
import { useDispatch, useSelector } from "react-redux";
import { announcements } from "./model/announcement-action";



export default function AnnouncementBanner(props) {
    const languageCode = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
    const announcementDetails = useSelector((state) =>state?.announcementReducer?.annResults?.data?.getAnnouncementList);
    const dispatch = useDispatch();

    useEffect(() => {
      
        if(!announcementDetails){
        if (languageCode) {
            (async () => {
                await dispatch(announcements(languageCode));
            })();
        }
       }
    }, [languageCode,announcementDetails]);


    return (
        <div>
            <Announcement />
            <AnnouncementPopup />
        </div>
    );
}
